module.exports = "/static/assets/d70269b2caad2491ee6da299fbf75e72.gif";